﻿let $ = require('jQuery');

module.exports = ExpandableList;

function ExpandableList(options) {
    let defaultOptions = {
        loadMoreElement: $(''),
        elements: [],
        hiddenClass: 'hidden',
        onListExpanded: () => { }
    };

    options = $.extend({}, defaultOptions, options);

    options.loadMoreElement.click(function () {
        options.elements.each(function () {
            $(this).removeClass(options.hiddenClass);
        });

        options.loadMoreElement.hide();
        options.onListExpanded();
    });
}